import { ConnectedRouter } from 'connected-react-router';
import ClientConfig from '~client/config';
import { Switch } from 'react-router-dom';
import { Provider } from 'react-redux';
import { ErrorBoundary, Toaster } from '@oliasoft-open-source/react-ui-library';
import { PkceSecure, PkceProvider } from '@oliasoft/pkce';
import MainRoutesContainer from './layout/MainRoutesContainer';
import { history, store } from './reduxStore';

export default function App() {
  return (
    <Provider store={store}>
      <PkceProvider
        provider={ClientConfig.config.pkce.provider}
        renewTokenMode={ClientConfig.config.pkce.renewTokenMode}
        clientId={ClientConfig.config.clientId}
        idpServerUrl={ClientConfig.config.idpServerUrl}
        hostBaseUrl={ClientConfig.config.hostBaseUrl}
        history={history}
      >
        <ConnectedRouter history={history}>
          <ErrorBoundary>
            <PkceSecure>
              <Switch>
                <MainRoutesContainer history={history} />
              </Switch>
              <Toaster />
              <div id="modalPortals" />
            </PkceSecure>

          </ErrorBoundary>
        </ConnectedRouter>
      </PkceProvider>
    </Provider>
  );
}
